import ActionButton from "components/Buttons/ActionButton";
import useFormHelpers from "../FormScript/hooks/useFormHelpers";

export default function BtnDownload() {
  const { payload } = useFormHelpers();

  function onDownload() {
    let scriptText = "";
    scriptText += `Title: ${payload.title}\n`;
    scriptText += `Status: ${payload.status}\n`;
    scriptText += `Description: ${payload.description}\n`;
    scriptText += `Language: ${payload.languageCode}\n`;
    scriptText += `Start Date: ${payload.startDate}\n`;
    scriptText += `End Date: ${payload.startDate}\n\n`;
    payload.questions.forEach((question) => {
      scriptText += `Q${question.orderNumber} [${question.type}]: ${question.title}\n\n`;
    });

    const blob = new Blob([scriptText], {
      type: "text/plain;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${payload.title || "VidletScript"}.txt`;
    link.click();

    URL.revokeObjectURL(url);
  }

  return <ActionButton onClick={onDownload}>DOWNLOAD SCRIPT</ActionButton>;
}
